<template>
  <div v-observe-visibility="{
         callback: onVisible,
         intersection:{
           rootMargin: '0px -40% 0px -40%',
         }
  }">
    <slot name='default' />
  </div>
  
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods:{
    onVisible(visible) {
      this.$emit('visible', {
        visible,
        data:this.data
      });
    }
  }
}
</script>
